export default {
  "content": "<g clip-path=\"url(#clip0_877_61437)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.333 2.167v10A1.666 1.666 0 0025 13.833h10v25a1.667 1.667 0 01-1.667 1.667h-25a1.667 1.667 0 01-1.666-1.667v-35a1.667 1.667 0 011.666-1.666h15zm-11.666 35H20a1.667 1.667 0 000-3.334h-8.333a1.667 1.667 0 000 3.334zm0-6.667H30a1.667 1.667 0 000-3.333H11.667a1.667 1.667 0 000 3.333zm19.512-7.155A1.666 1.666 0 0030 20.5H11.667a1.667 1.667 0 000 3.333H30c.442 0 .866-.175 1.179-.488zM26.667 10.5V2.167L35 10.5h-8.333z\" fill=\"#A4A9B6\"/></g><defs><clipPath id=\"clip0_877_61437\"><path fill=\"#fff\" transform=\"translate(0 .5)\" d=\"M0 0h40v40H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "40",
    "height": "41",
    "viewBox": "0 0 40 41",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};